import React from 'react';
import {
    Table,
    Space,
    Statistic
} from 'antd';
import EditFormModal from './EditFormModal';
import DeletePopupButton from './DeletePopupButton';

const columns = [
    {
        title: 'สินค้า',
        dataIndex: 'product',
        key: 'product',
        render: (text, _) => `${text?.name}:${text?.brand.name} ${text?.description}`
    },
    {
        title: 'ราคา',
        dataIndex: 'price',
        key: 'price',
        render: (text, _) => <Statistic value={text} precision={2} valueStyle={{ fontSize: 14 }} />
    },
    {
        title: 'จำนวน',
        dataIndex: 'quantity',
        key: 'quantity',
    },
    {
        title: '',
        dataIndex: 'action',
        key: 'action',
        render: (_, record) => (
            <Space size="middle">
                <EditFormModal data={record} />
                <DeletePopupButton data={record} />
            </Space>
        )
    },
];


function CartItems({ products }) {
    return (
        <div>
            <Table
                rowKey={(record) => record._id}
                columns={columns}
                dataSource={products}
            // scroll={{
            //     x: 1200,
            // }}
            />
        </div>
    )
}

export default CartItems